'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_ImageSearch(recipe, pageIndex, pageSize, sort) {
  this.Lw = null;
  this.Lu = 0;
  this.Lv = 0;
  this.Lx = null;
  this.Lw = recipe;
  this.Lu = pageIndex;
  this.Lv = pageSize;
  this.Lx = sort;
}
export { $c_Lmealorama_ImageSearch as $c_Lmealorama_ImageSearch };
$p = $c_Lmealorama_ImageSearch.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_ImageSearch;
/** @constructor */
function $h_Lmealorama_ImageSearch() {
}
export { $h_Lmealorama_ImageSearch as $h_Lmealorama_ImageSearch };
$h_Lmealorama_ImageSearch.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (-466095421));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.Lw));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, this.Lu);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, this.Lv);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.Lx));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 4);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_ImageSearch)) {
    if (((this.Lu === x$0.Lu) && (this.Lv === x$0.Lv))) {
      var x = this.Lw;
      var x$2 = x$0.Lw;
      var $x_1 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Lx;
      var x$4 = x$0.Lx;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 4;
});
$p.r = (function() {
  return "ImageSearch";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.Lw;
      break;
    }
    case 1: {
      return this.Lu;
      break;
    }
    case 2: {
      return this.Lv;
      break;
    }
    case 3: {
      return this.Lx;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_ImageSearch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jB)));
}
export { $isArrayOf_Lmealorama_ImageSearch as $isArrayOf_Lmealorama_ImageSearch };
var $d_Lmealorama_ImageSearch = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_ImageSearch, "mealorama.ImageSearch", ({
  jB: 1,
  bB: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_ImageSearch as $d_Lmealorama_ImageSearch };
//# sourceMappingURL=mealorama.-Image-Search.js.map
